const EVENT_NAMES = {
  LOGIN_ATTEMPT: "Login Attempt",
  LOGIN_SUCCESS: "Login Success",
  LOGIN_FAILED: "Login Failed",
  SIGNUP_ATTEMPT: "Sign Up Attempt",
  SIGNUP_SUCCESS: "Sign Up Success",
  SIGNUP_FAILED: "Sign Up Failed",
  FORGOT_PASSWORD_ATTEMPT: "Forgot Password Attempt",
  FORGOT_PASSWORD_SUCCESS: "Forgot Password Success",
  FORGOT_PASSWORD_FAILED: "Forgot Password Failed",
  SEARCH_ATTEMPT: "Search Attempt",
  VIEW_VENDOR_DETAILS: "Vendor Details Viewed",
  VIEW_VENDOR_DETAILS_FAILED: "Vendor Details View Failed",
  LOGOUT_SUCCESS: "Logout",
  ADD_ITEM_TO_CART: "Item Added To Cart",
  REMOVED_CART: "Cart Removed",
  CART_CLEARED: "Cart Cleared",
  ORDER_PLACED: "Order Placed",
  PROFILE_UPDATED: "Profile Updated",
  ADDRESS_ADDED: "Address Added",
  ADDRESS_UPDATED: "Address Updated",
  ADDRESS_DELETED: "Address Deleted",
  LOCATION_UPDATED: "Current Location Updated",
};

module.exports = EVENT_NAMES;
